import { Card } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import LeadStatusChip from "../../Subcomponents/LeadStatusChip";
import Dot from "../Icons/Dot";
import cssClasses from "./PreselectAllotments.module.css";
import ReactTimeAgo from "react-time-ago";
import Button from "../../Subcomponents/Button";
import MyTimer from "../../Subcomponents/Timer";
import PreselectBuildingIcon from "../../Assets/Images/Common/AllotmentBuildingIcon.svg";
import PreselectCalenderIcon from "../../Assets/Images/Common/AllotmentCalender.svg";
import { supabase } from "../../supabaseClient";
import { getTokenServerTime } from "../../Services/Tokens";
import { getPaymentPlansPriceFromServer, getPreselectConfirmationsConfig } from "../../Services/Allotment";
import { errorTost } from "../../Services/Toast";
import DiscountImg from "../../Assets/Images/Common/disountImg.PNG";

const PreselectAllotmentCard = ({
	allotment: _allotment,
	serverTime: _serverTime,
	setOpenConfirmationModal,
	setAllotment,
	getLeadConfirmations,
	numberWithCommas,
	updatedRecord = [],
}) => {
	const [allotment, set_Allotment] = useState({ ..._allotment } || {});
	const [serverTime, setServerTime] = useState(_serverTime || "");
	const [updatedUnitCost, setUpdatedUnitCost] = useState({
		bsp: "",
		gst: "",
		sdr: "",
		total: "",
	});
	const timeoutId1 = useRef(null);
	const msgTimeoutId1 = useRef(null);
	const timeoutId2 = useRef(null);
	const msgTimeoutId2 = useRef(null);
	const expiretimeoutId = useRef(null);

	useEffect(() => {
		setTimeout(() => {
			getServerTime();
		}, 1000);
	}, []);

	useEffect(() => {
		let newAllotment = { ...allotment };
		getTokenServerTime()
			.then((res) => {
				setServerTime(res?.data?.currentTime);
				const time = res?.data?.currentTime;
				if (allotment?.launchId) {
					getPreselectConfirmationsConfig(
						newAllotment?.paymentId?.eventId?.eventId,
						newAllotment?.paymentId?.eventTokenId?.eventTokenId,
						newAllotment?.launchId
					)
						.then((val) => {
							newAllotment.showPreselectPrices = val?.data?.length > 0 ? val?.data[0]?.showPreselectPrices : [];
							newAllotment.showConfirmBtn = false;
							newAllotment.showMsg = false;
							newAllotment.isExpired = false;
							newAllotment.discountPercentage = val?.data?.length > 0 ? val?.data[0]?.priceDiscount : 0;
							// newAllotment.showPreselectPrices =
							//   val?.data?.length > 0 ? val?.data[0]?.showPreselectPrices : [];
							newAllotment.paymentId.eventId.preselectConfirmationConfig =
								val?.data?.length > 0
									? val?.data[0]?.preselectConfirmationConfig
									: newAllotment.paymentId.eventId.preselectConfirmationConfig;
							if (
								newAllotment.paymentId?.eventId?.preselectConfirmationConfig?.endDateTime - Date.now() <=
								parseInt(newAllotment.paymentId?.eventId?.preselectConfirmationConfig?.timer) * 60000
							) {
								newAllotment.expiry = newAllotment.paymentId?.eventId?.preselectConfirmationConfig?.endDateTime;
								getServerTime();
							} else {
								console.log("expiry", false);
							}
							if (
								val?.data?.length > 0
									? val?.data[0]?.preselectConfirmationConfig?.startDateTime
									: newAllotment.paymentId?.eventId?.preselectConfirmationConfig?.startDateTime > time
							) {
								clearTimeout(timeoutId2.current);
								clearTimeout(timeoutId1.current);
								// getServerTime()
								timeoutId1.current = setTimeout(() => {
									set_Allotment({
										...allotment,
										discountPercentage: val?.data?.length > 0 ? val?.data[0]?.priceDiscount : 0,
										showPreselectPrices: val?.data?.length > 0 ? val?.data[0]?.showPreselectPrices : [],
										closeTimer:
											val?.data?.length > 0
												? val?.data[0]?.preselectConfirmationConfig?.endDateTime
												: newAllotment.paymentId?.eventId?.preselectConfirmationConfig?.endDateTime,
										timer:
											val?.data?.length > 0
												? val?.data[0]?.preselectConfirmationConfig?.startDateTime
												: newAllotment.paymentId?.eventId?.preselectConfirmationConfig?.startDateTime,
										showConfirmBtn: true,
										showMsg: false,
									});
								}, newAllotment.paymentId?.eventId?.preselectConfirmationConfig?.startDateTime - time);
								clearTimeout(expiretimeoutId.current);
								expiretimeoutId.current = setTimeout(() => {
									set_Allotment({
										...allotment,
										discountPercentage: val?.data?.length > 0 ? val?.data[0]?.priceDiscount : 0,
										showPreselectPrices: val?.data?.length > 0 ? val?.data[0]?.showPreselectPrices : [],
										closeTimer:
											val?.data?.length > 0
												? val?.data[0]?.preselectConfirmationConfig?.endDateTime
												: newAllotment.paymentId?.eventId?.preselectConfirmationConfig?.endDateTime,
										timer:
											val?.data?.length > 0
												? val?.data[0]?.preselectConfirmationConfig?.startDateTime
												: newAllotment.paymentId?.eventId?.preselectConfirmationConfig?.startDateTime,
										showConfirmBtn: false,
										showMsg: false,
										isExpired: true,
									});
								}, newAllotment.paymentId?.eventId?.preselectConfirmationConfig?.endDateTime - time)
								if (
									val?.data?.length > 0 &&
									val?.data[0]?.preselectConfirmationConfig?.startDateTime > time &&
									newAllotment.preselectConfirmation === "confirmation pending"
								) {
									clearTimeout(msgTimeoutId2.current);
									clearTimeout(msgTimeoutId1.current);
									msgTimeoutId1.current = setTimeout(() => {
										set_Allotment({
											...allotment,
											discountPercentage: val?.data?.length > 0 ? val?.data[0]?.priceDiscount : 0,
											showPreselectPrices: val?.data?.length > 0 ? val?.data[0]?.showPreselectPrices : [],
											showMsg: true,
											showConfirmBtn: false,
										});
									}, newAllotment?.paymentId?.eventId?.preselectConfirmationConfig?.startDateTime - newAllotment?.paymentId?.eventId?.preselectConfirmationConfig?.timer * 60000 - time);
								}
							} else {
								newAllotment.timer =
									val?.data?.length > 0
										? val?.data[0]?.preselectConfirmationConfig?.startDateTime
										: newAllotment.paymentId?.eventId?.preselectConfirmationConfig?.startDateTime;
								newAllotment.closeTimer =
									val?.data?.length > 0
										? val?.data[0]?.preselectConfirmationConfig?.endDateTime
										: newAllotment.paymentId?.eventId?.preselectConfirmationConfig?.endDateTime;
							}
							set_Allotment(newAllotment);
						})
						.catch((err) => { });
				} else {
					newAllotment.showConfirmBtn = false;
					newAllotment.showMsg = false;
					newAllotment.discountPercentage = 0;
					newAllotment.showPreselectPrices = [];
					if (
						newAllotment.paymentId?.eventId?.preselectConfirmationConfig?.endDateTime - Date.now() <=
						parseInt(newAllotment.paymentId?.eventId?.preselectConfirmationConfig?.timer) * 60000
					) {
						newAllotment.expiry = newAllotment.paymentId?.eventId?.preselectConfirmationConfig?.endDateTime;
					} else {
						console.log("expiry", false);
					}
					if (newAllotment.paymentId?.eventId?.preselectConfirmationConfig?.startDateTime > new Date().getTime()) {
						setTimeout(() => {
							set_Allotment({
								...allotment,
								closeTimer: newAllotment.paymentId?.eventId?.preselectConfirmationConfig?.endDateTime,
								timer: newAllotment.paymentId?.eventId?.preselectConfirmationConfig?.startDateTime,
								showConfirmBtn: true,
							});
						}, newAllotment.paymentId?.eventId?.preselectConfirmationConfig?.startDateTime - new Date().getTime());
					} else {
						newAllotment.timer = newAllotment.paymentId?.eventId?.preselectConfirmationConfig
							? newAllotment.paymentId?.eventId?.preselectConfirmationConfig?.startDateTime
							: null;
						newAllotment.closeTimer = newAllotment.paymentId?.eventId?.preselectConfirmationConfig
							? newAllotment.paymentId?.eventId?.preselectConfirmationConfig?.endDateTime
							: null;
					}
					set_Allotment(newAllotment);
				}
			})
			.catch((error) => {
				console.log("err in getQueueStatus api call", error);
			});
	}, []);
	useEffect(() => {
		const handleRecordUpdated = updatedRecord.find(
			(token) =>
				token?.new.launchId == allotment?.launchId &&
				token.new.eventId == allotment?.paymentId?.eventId?.eventId &&
				token.new.eventTokenId == allotment?.paymentId?.eventTokenId?.eventTokenId
		);
		if (handleRecordUpdated) {
			getTokenServerTime()
				.then((res) => {
					setServerTime(res?.data?.currentTime);
					setnewConfig(handleRecordUpdated, res?.data?.currentTime);
				})
				.catch((error) => {
					console.log("err in getQueueStatus api call", error);
				});
		}
	}, [updatedRecord]);
	useEffect(() => {
		if (_allotment?.paymentPlanId) {
			getPaymentPlansPriceFromServer(_allotment?.paymentPlanId, _allotment?.unitId?.unitId)
				.then((planResp) => {
					if (planResp?.data[0]) {
						setUpdatedUnitCost({
							bsp: planResp.data[0]?.BSP,
							gst: planResp.data[0]?.GST,
							sdr: planResp.data[0]?.SDR,
							total: planResp.data[0]?.totalCost,
						});
					} else {
						setUpdatedUnitCost({
							bsp: _allotment?.unitId?.BSP,
							gst: _allotment?.unitId?.GST,
							sdr: _allotment?.unitId?.SDR,
							total: _allotment?.unitId?.totalCost,
						});
					}
				})
				.catch((err) => {
					setUpdatedUnitCost({
						bsp: _allotment?.unitId?.BSP,
						gst: _allotment?.unitId?.GST,
						sdr: _allotment?.unitId?.SDR,
						total: _allotment?.unitId?.totalCost,
					});
					errorTost("Error While getting Payment Plan Details.");
					console.log(err.message);
				});
		} else {
			setUpdatedUnitCost({
				bsp: _allotment?.unitId?.BSP,
				gst: _allotment?.unitId?.GST,
				sdr: _allotment?.unitId?.SDR,
				total: _allotment?.unitId?.totalCost,
			});
		}
	}, [_allotment]);

	const getServerTime = async () => {
		getTokenServerTime()
			.then((res) => {
				setServerTime(res?.data?.currentTime);
			})
			.catch((error) => {
				console.log("err in getQueueStatus api call", error);
			});
	};
	const setnewConfig = (newConfigData, time = serverTime) => {
		let newAllotment = { ...allotment };
		newAllotment.showPreselectPrices = newConfigData.new.showPreselectPrices;
		newAllotment.showConfirmBtn = false;
		newAllotment.showMsg = false;
		newAllotment.isExpired = false;
		newAllotment.paymentId.eventId.preselectConfirmationConfig = newConfigData.new.preselectConfirmationConfig;

		if (
			newAllotment.paymentId?.eventId?.preselectConfirmationConfig?.endDateTime - Date.now() <=
			parseInt(newAllotment.paymentId?.eventId?.preselectConfirmationConfig?.timer) * 60000
		) {
			console.log("expiry", true);
			newAllotment.expiry = newAllotment.paymentId?.eventId?.preselectConfirmationConfig?.endDateTime;
			console.log("newAllotment.expiry: ", newAllotment.expiry);
			getServerTime();
		} else {
			console.log("expiry", false);
		}
		if (
			newConfigData.new.preselectConfirmationConfig?.startDateTime > time ||
			time < newConfigData.new.preselectConfirmationConfig?.endDateTime
		) {
			clearTimeout(timeoutId1.current);
			clearTimeout(timeoutId2.current);
			timeoutId2.current = setTimeout(() => {
				set_Allotment({
					...allotment,
					discountPercentage: newConfigData.new.priceDiscount ? newConfigData.new.priceDiscount : 0,
					showPreselectPrices: newConfigData.new.showPreselectPrices,
					closeTimer: newConfigData.new.preselectConfirmationConfig?.endDateTime,
					timer: newConfigData.new.preselectConfirmationConfig?.startDateTime,
					showConfirmBtn: true,
					showMsg: false,
				});
			}, newConfigData.new.preselectConfirmationConfig?.startDateTime - time);
			clearTimeout(expiretimeoutId.current);
			expiretimeoutId.current = setTimeout(() => {
				set_Allotment({
					...allotment,
					discountPercentage: newConfigData.new.priceDiscount
						? newConfigData.new.priceDiscount
						: 0,
					showPreselectPrices: newConfigData.new.showPreselectPrices,
					closeTimer:
						newConfigData.new.preselectConfirmationConfig?.endDateTime,
					timer: newConfigData.new.preselectConfirmationConfig?.startDateTime,
					showConfirmBtn: false,
					showMsg: false,
					isExpired: true,
				});
			}, newConfigData.new.preselectConfirmationConfig?.endDateTime - time);
			if (
				newConfigData.new.preselectConfirmationConfig?.startDateTime > time &&
				newAllotment.preselectConfirmation === "confirmation pending"
			) {
				clearTimeout(msgTimeoutId1.current);
				clearTimeout(msgTimeoutId2.current);
				msgTimeoutId2.current = setTimeout(() => {
					set_Allotment({
						...allotment,
						discountPercentage: newConfigData.new.priceDiscount ? newConfigData.new.priceDiscount : 0,
						showPreselectPrices: newConfigData.new.showPreselectPrices,
						showMsg: true,
						showConfirmBtn: false,
					});
				}, newAllotment?.paymentId?.eventId?.preselectConfirmationConfig?.startDateTime - newAllotment?.paymentId?.eventId?.preselectConfirmationConfig?.timer * 60000 - time);
			}
		}
		set_Allotment(newAllotment);
	};
	function arrayContains(key, arr) {
		if (arr?.length > 0) {
			return arr.indexOf(key) > -1;
		} else {
			return false;
		}
	}
	return (
		<Card className={cssClasses.eventWrap} key={allotment.allotmentPaymentId} style={{ borderRadius: "20px", boxShadow: "none" }}>
			<div className={cssClasses.cardHeader}>
				<div className={cssClasses.tokenNumWrap}>
					<div className={cssClasses.buildingImg}>
						<img src={PreselectBuildingIcon} alt="building" />
					</div>
					<div className={cssClasses.allotmentProjectDetail}>
						<div className={cssClasses.allotmentProjectDetailFirst}>
							<>
								{allotment?.unitId && (
									<span>
										{allotment?.unitId.wingId.displayName
											? allotment?.unitId.wingId.displayName
											: allotment?.unitId.wingId.wingName}{" "}
										- {allotment?.unitId.unitNo}{" "}
									</span>
								)}
								{allotment?.inventoryMergedId &&
									((allotment?.inventoryMergedId.unit1Id.wingId.wingId === allotment?.inventoryMergedId.unit2Id.wingId.wingId && (
										<span>
											{allotment?.inventoryMergedId.unit1Id.wingId.displayName
												? allotment?.inventoryMergedId.unit1Id.wingId.displayName
												: allotment?.inventoryMergedId.unit1Id.wingId.wingName}{" "}
											- {allotment?.inventoryMergedId.unit1Id.unitNo} & {allotment?.inventoryMergedId.unit2Id.unitNo}{" "}
										</span>
									)) ||
										(allotment?.inventoryMergedId.unit1Id.wingId.wingId !==
											allotment?.inventoryMergedId.unit2Id.wingId.wingId && (
												<span>
													{allotment?.inventoryMergedId.unit1Id.wingId.displayName
														? allotment?.inventoryMergedId.unit1Id.wingId.displayName
														: allotment?.inventoryMergedId.unit1Id.wingId.wingName}{" "}
													- {allotment?.inventoryMergedId.unit1Id.unitNo} &{" "}
													{allotment?.inventoryMergedId.unit2Id.wingId.displayName
														? allotment?.inventoryMergedId.unit2Id.wingId.displayName
														: allotment?.inventoryMergedId.unit2Id.wingId.wingName}{" "}
													- {allotment?.inventoryMergedId.unit2Id.unitNo}{" "}
												</span>
											)))}
							</>
							<div className={cssClasses.tokenStatus}>
								{allotment.preselectConfirmation === "confirmed" &&
									allotment.status !== "Cancelled" &&
									!allotment.status.includes("Refund") && (
										<LeadStatusChip
											label={allotment.preselectConfirmation}
											icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
											style={{
												color: "#027A48",
												backgroundColor: "#ECFDF3",
											}}
										></LeadStatusChip>
									)}
								{allotment.preselectConfirmation === "confirmation pending" &&
									allotment.status !== "Cancelled" &&
									!allotment.status.includes("Refund") && (
										<LeadStatusChip
											label={allotment.preselectConfirmation}
											icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
											style={{
												color: "#B42318",
												backgroundColor: "#FEF3F2",
											}}
										></LeadStatusChip>
									)}
								{(allotment.preselectConfirmation === "pending" || allotment.preselectConfirmation === "payment pending") &&
									allotment.status !== "Cancelled" &&
									!allotment.status.includes("Refund") && (
										<LeadStatusChip
											label={allotment.preselectConfirmation}
											icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
											style={{
												color: "#B54708",
												backgroundColor: "#FFFAEB",
											}}
										></LeadStatusChip>
									)}
								{(allotment.preselectConfirmation === "not confirmed" || allotment.preselectConfirmation === "payment not done") &&
									!allotment.status.includes("Refund") && (
										<LeadStatusChip
											label={allotment.preselectConfirmation}
											icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
											style={{
												color: "#0E7090",
												backgroundColor: "#ECFDFF",
											}}
										></LeadStatusChip>
									)}
								{allotment.status === "Cancelled" && !allotment.status.includes("Refund") && (
									<LeadStatusChip
										label={allotment.status}
										icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
										style={{
											color: "rgb(180, 35, 24)",
											backgroundColor: "rgb(254, 243, 242)",
										}}
									></LeadStatusChip>
								)}
								{allotment.status.includes("Refund") && (
									<LeadStatusChip
										label={allotment.status}
										icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
										style={{
											color: "rgb(180, 35, 24)",
											backgroundColor: "rgb(254, 243, 242)",
										}}
									></LeadStatusChip>
								)}
							</div>
						</div>
						<div className={cssClasses.allotmentProjectDetailSec}>
							{allotment?.unitId && <span>{allotment?.unitId.projectId.projectName}</span>}
							{allotment?.inventoryMergedId && <span>{allotment?.inventoryMergedId.projectId.projectName}</span>}
						</div>
					</div>
				</div>
				<div className={cssClasses.tokenLastUpdate}>
					<ReactTimeAgo style={{ fontSize: "1.2rem" }} date={allotment?.last_updated_at ?? allotment?.created_at} locale="en-US" />
				</div>
			</div>
			<div className={cssClasses.cardDetails}>
				<div className={cssClasses.tokenDetails}>
					{allotment.paymentId && (
						<div className={cssClasses.tokenData}>
							<span>{allotment.paymentId?.eventTokenId?.eventId?.title}</span>
						</div>
					)}
					<div className={cssClasses.unitDetailsData}>
						{allotment.unitId && <span>{allotment.unitId.inventoryTypeId.type}</span>}
						{allotment.inventoryMergedId && (
							<>
								<span>
									{allotment.inventoryMergedId.unit1Id.inventoryTypeId.type} -{" "}
									{allotment.inventoryMergedId.unit2Id.inventoryTypeId.type}
								</span>
							</>
						)}
						<span>{" • "}</span>
						{allotment.unitId && <span>{allotment.unitId.floorNo}</span>}
						{allotment.inventoryMergedId && (
							<>
								{allotment.inventoryMergedId.unit1Id.floorNo === allotment.inventoryMergedId.unit2Id.floorNo && (
									<span>{allotment.inventoryMergedId.unit1Id.floorNo}</span>
								)}
								{allotment.inventoryMergedId.unit1Id.floorNo !== allotment.inventoryMergedId.unit2Id.floorNo && (
									<span>
										{allotment.inventoryMergedId.unit1Id.floorNo} - {allotment.inventoryMergedId.unit2Id.floorNo}
									</span>
								)}
							</>
						)}
						<span>{" • "}</span>
						<span>{allotment.paymentId.eventId.title}</span>
						<span>{" • "}</span>
						<span>{allotment.paymentId.tokenNumber}</span>
					</div>
					<div className={cssClasses.timerView}>
						<div className={cssClasses.allotmentDate}>
							<div className={cssClasses.allotmentDateData}>
								<img src={PreselectCalenderIcon} alt="Calender-check" />
								Alloted On:
							</div>
							<div className={cssClasses.allotmentDate}>
								{new Date(allotment.created_at).toDateString()},{" "}
								{new Date(allotment.created_at).toLocaleTimeString([], {
									hour: "2-digit",
									minute: "2-digit",
								})}
							</div>
						</div>

						{allotment.status !== "Cancelled" &&
							!allotment.status.includes("Refund") &&
							allotment.showConfirmBtn &&
							allotment.preselectConfirmation === "confirmation pending" && (
								<>
									<div className={cssClasses.timerWrap}>
										<MyTimer
											css={{
												fontSize: "1.4rem",
												color: "#E17A00",
											}}
											preselectConfirm={true}
											expiryTimestamp={allotment.closeTimer}
											onExpire={() => {
												getLeadConfirmations() && setOpenConfirmationModal(false);
											}}
										/>
									</div>
								</>
							)}
					</div>
					<div className={cssClasses.paymentText}>
						{allotment.paidAmount < allotment.paymentId.amount ? (
							<>
								<p
									style={{
										fontSize: "1.4rem",
										fontStyle: "italic",
										color: "red",
									}}
								>
									Please complete payment!
								</p>
							</>
						) : (
							<>
								{allotment.showMsg && !allotment.showConfirmBtn && allotment.preselectConfirmation === "confirmation pending" && !allotment.isExpired ? (
									<>
										<p
											style={{
												fontSize: "1.4rem",
												fontStyle: "italic",
											}}
										>
											Preselect Confirmations will start from{" "}
											<b>
												{new Date(allotment?.paymentId?.eventId?.preselectConfirmationConfig?.startDateTime).toDateString()}{" "}
												{new Date(
													allotment?.paymentId?.eventId?.preselectConfirmationConfig?.startDateTime
												).toLocaleTimeString()}
											</b>
										</p>
									</>
								) : !allotment.showConfirmBtn && !allotment.showMsg && allotment.preselectConfirmation === "confirmation pending" && !allotment.isExpired ? (
									<>
										<p
											style={{
												fontSize: "1.4rem",
												fontStyle: "italic",
											}}
										>
											Preselect Confirmations will start soon!
										</p>
									</>
								) : (
									""
								)}
							</>
						)}
					</div>
				</div>
			</div>

			<div className={cssClasses.cardFooter}>
				{allotment.showConfirmBtn && allotment.preselectConfirmation === "confirmation pending" && allotment?.status !== "Cancelled" && (
					<div className={cssClasses.allotmentPaymentPriceBreakDown}>
						{arrayContains("BSP", allotment.showPreselectPrices) && (
							<div className={cssClasses.allotmentPaymentPrice1}>
								<span className={cssClasses.allotmentPriceText}>Agreement Value:</span>
								<span>₹ {numberWithCommas(updatedUnitCost?.bsp)}</span>
							</div>
						)}

						{arrayContains("SDR", allotment.showPreselectPrices) && (
							<div className={cssClasses.allotmentPaymentPrice1}>
								<span className={cssClasses.allotmentPriceText}>SDR :</span>
								<span>₹ {numberWithCommas(updatedUnitCost?.sdr)}</span>
							</div>
						)}

						{arrayContains("GST", allotment.showPreselectPrices) && (
							<div className={cssClasses.allotmentPaymentPrice1}>
								<span className={cssClasses.allotmentPriceText}>GST :</span>
								<span>₹ {numberWithCommas(updatedUnitCost?.gst)}</span>
							</div>
						)}
					</div>
				)}
				<div className={cssClasses.cardFooterSecData}>
					{allotment.status !== "Cancelled" &&
						!allotment.status.includes("Refund") &&
						allotment.showConfirmBtn &&
						allotment.preselectConfirmation === "confirmation pending" && (
							<div className={cssClasses.totalAmt}>
								<span className={cssClasses.amtBtnsText}>Total Cost (CLP) : </span>
								<span>₹ {numberWithCommas(updatedUnitCost?.total)}</span>
								 <div
										style={{
											fontSize: "8px",
											display: "flex",
											justifyContent: "flex-start",
											alignItems: "flex-start",
											width: "100%"
										}}
										>
										CLP = Construction Link Payment Plan.
										</div>
							</div>
						)}
					<div className={cssClasses.confirmBtnWrap}>
						{allotment.status !== "Cancelled" &&
							!allotment.status.includes("Refund") &&
							allotment.showConfirmBtn &&
							allotment.preselectConfirmation === "confirmation pending" && (
								<>
									<Button
										btnName={"Confirm"}
										clicked={() => {
											setAllotment(allotment);
											setOpenConfirmationModal(true);
											// submitConfirmation(allotment);
										}}
										style={{
											width: window.innerWidth > 1366 ? "100%" : "100%",
											color: "#fff",
											backgroundColor: "rgb(21, 112, 239)",
											fontSize: "1.4rem",
											lineHeight: "2rem",
											fontFamily: "Inter-Medium !important",
										}}
									></Button>
								</>
							)}
					</div>
				</div>
				<div className={cssClasses.confirmBtnWrap} style={{ width: "100%" }}>
					{(allotment?.eventId === "3ee672b5-e700-4eb6-be77-d1b6b0516015" || allotment?.eventId === "b0fa00c7-e2da-4695-8e88-111e7b28a812") && allotment.status !== "Cancelled" &&
						!allotment.status.includes("Refund") &&
						allotment.showConfirmBtn &&
						allotment.preselectConfirmation === "confirmation pending" && (
							<div  style={{ padding: "1rem", textAlign: "left", backgroundColor: "#efa04cff", width: "100%" }}>
								<div style={{ fontWeight: "bold", fontSize: "1.4rem"  }}>CONFIRM Now, Decide Later! </div>
								<div style={{ fontSize: "1.4rem" }}>For No Pre-EMI price, please refer detailed pricelist. Offer applicable only to PreSelect units.</div>
							</div>
						)}
				</div>
				{/* {allotment?.eventId === "6e4e8aad-72fd-4e95-b6cf-48cc69c9005a" && allotment?.launchId === "c28e61d4-4c45-4369-bd5d-adfa289ef443" &&
							<div className={cssClasses.imageContainer}>
								<img src={DiscountImg} alt="Discount image" />
							</div>
						} */}
			</div>
		</Card>
	);
};

export default PreselectAllotmentCard;